import {httpCall, httpMethod} from "./http";

export const geoCodeByAddress = address => {
	return httpCall( httpMethod.GET, `/geocode/${ btoa( address ) }` )
}


export const storeGeoCodeByAddress = ({address: address, lat: lat, lng: lng}) => {
	return httpCall( httpMethod.POST, `/geocode/${ btoa( address ) }`, {lat: lat, lng: lng} )
}

export const searchAddressByCoordPoint = (lat, lng, ray) => {

}
